import React from "react";
import { CONFIG } from "../config/config";
import { useLocation } from "react-router-dom";

export default function PageDebug({ patients = [] }) {
  const location = useLocation();

  if (!CONFIG.DEBUG) {
    return (
      <div className="p-4 text-gray-600 text-center">Mode debug désactivé.</div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold text-red-600 mb-4">🪲 Debug Page</h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Informations générales</h2>
        <ul className="list-disc list-inside text-sm">
          <li>
            <strong>API URL :</strong> {CONFIG.API_BASE_URL}
          </li>
          <li>
            <strong>WebSocket URL :</strong> {CONFIG.API_URL}
          </li>
          <li>
            <strong>Chemin actuel :</strong> {location.pathname}
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Patients actuels</h2>
        {patients.length > 0 ? (
          <table className="table-auto w-full text-xs border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-1">ID</th>
                <th className="border p-1">Nom</th>
                <th className="border p-1">Prénom</th>
                <th className="border p-1">Step</th>
                <th className="border p-1">Statut</th>
              </tr>
            </thead>
            <tbody>
              {patients.map((p) => (
                <tr key={p.id} className="hover:bg-gray-50">
                  <td className="border p-1">{p.id}</td>
                  <td className="border p-1">{p.nom}</td>
                  <td className="border p-1">{p.prenom}</td>
                  <td className="border p-1">{p.currentStep}</td>
                  <td className="border p-1">{p.statut}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-sm text-gray-500">Aucun patient chargé.</p>
        )}
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">ENV & Config</h2>
        <pre className="bg-white p-2 border text-xs overflow-x-auto">
          {JSON.stringify(CONFIG, null, 2)}
        </pre>
      </section>
    </div>
  );
}
